import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Users, Shield, Database, Key } from 'lucide-react';
import Button from '../../common/Button';

const OpenLDAPSolution = () => {
  const { t } = useTranslatedContent('openldap');

  const features = {
    directory: {
      title: t('features.items.0.title'),
      description: t('features.items.0.description')
    },
    security: {
      title: t('features.items.1.title'),
      description: t('features.items.1.description')
    },
    availability: {
      title: t('features.items.2.title'),
      description: t('features.items.2.description')
    },
    identity: {
      title: t('features.items.3.title'),
      description: t('features.items.3.description')
    }
  };

  return (
    <div className="bg-gradient-to-br from-green-900 to-emerald-900 rounded-3xl p-8 lg:p-12 text-white">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-semibold">{t('title')}</h3>
        <p className="mt-4 text-green-100">{t('subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Users className="h-8 w-8 text-green-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.directory.title}</h4>
          <p className="text-green-100">{features.directory.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Shield className="h-8 w-8 text-green-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.security.title}</h4>
          <p className="text-green-100">{features.security.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Database className="h-8 w-8 text-green-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.availability.title}</h4>
          <p className="text-green-100">{features.availability.description}</p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Key className="h-8 w-8 text-green-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{features.identity.title}</h4>
          <p className="text-green-100">{features.identity.description}</p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Button
          variant="secondary"
          className="bg-white text-green-900 hover:bg-green-50"
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          {t('hero.buttonText')}
        </Button>
      </div>
    </div>
  );
};

export default OpenLDAPSolution;